export default __webpack_public_path__ + "static/media/ARE.cd6238db.svg";